import { useEffect, useState } from 'react'
import algoliasearch from 'algoliasearch/lite'
import {
  ALGOLIA_APP_ID,
  ALGOLIA_API_KEY,
  COACH_ACTIVITIES_INDEX_NAME,
} from 'env'
import { fetchCoachActivityHit } from '../lib/fetch-coach-activity-hit'

const searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_API_KEY)

const useCoachActivityHit = objectId => {
  const [hit, setHit] = useState(null)
  const [isLoading, setIsLoading] = useState(Boolean(objectId))

  useEffect(() => {
    let isMounted = true

    if (!objectId) {
      setHit(null)
      setIsLoading(false)
      return undefined
    }

    setIsLoading(true)
    setHit(null)

    fetchCoachActivityHit(searchClient, COACH_ACTIVITIES_INDEX_NAME, objectId)
      .then(nextHit => {
        if (isMounted) {
          setHit(nextHit)
        }
      })
      .catch(() => {
        if (isMounted) {
          setHit(null)
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false)
        }
      })

    return () => {
      isMounted = false
    }
  }, [objectId])

  return { hit, isLoading }
}

export default useCoachActivityHit
